import { getService } from '../../utils';

export const getGlobalSpaceService = getService('globalSpace');
